module.exports = __webpack_public_path__ + "img/t0.4d729864.png";